export const masterConstants = {
  FETCH_COMPANIES_ACTION_REQUEST: "FETCH_COMPANIES_ACTION_REQUEST",
  FETCH_COMPANIES_ACTION_SUCCESS: "FETCH_COMPANIES_ACTION_SUCCESS",
  FETCH_COMPANIES_ACTION_FAILURE: "FETCH_COMPANIES_ACTION_FAILURE",

  CREATE_COMPANY_ACTION_REQUEST: "CREATE_COMPANY_ACTION_REQUEST",
  CREATE_COMPANY_ACTION_SUCCESS: "CREATE_COMPANY_ACTION_SUCCESS",
  CREATE_COMPANY_ACTION_FAILURE: "CREATE_COMPANY_ACTION_FAILURE",
};
